import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { UserSimple } from '../models/UserSimple';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';

const URL = environment.apiBaseUrl;

@Injectable()
export class UserAccountService {
  constructor(private http: HttpClient) {}

  public userAccount(): Observable<UserSimple> {
    return this.http.get<UserSimple>(`${URL}/userAccount`);
  }

  public changePassword(oldPassword: string, newPassword: string) {
    return this.http.post(`${URL}/userAccount/changePassword`, {
      oldPassword: oldPassword,
      newPassword: newPassword
    });
  }

  public setPassword(newPassword: string, confirmPassword: string) {
    return this.http.post(`${URL}/userAccount/setPassword`, {
      newPassword: newPassword,
      confirmPassword: confirmPassword
    });
  }
}
